
const mediaRouter = {
  path: 'media',
  name: '多媒体',
  component: () => import('@/views/media/index.vue')
}
export default mediaRouter
